import {
  createPaginatedSupabaseQuery,
  createSearchSupabaseQuery,
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnGetApiFunction,
  spawnListInApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
  type SearchOptionFilters,
} from "@/utils/api";

import type { QueryPaginationFilters } from "@/utils/pagination";

const table = "part_manufacturers";
const query = `*, part_models(name)`;
export const apiConfigPartManufacturers: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name"],
  sortables: ["name", "created_at", "updated_at"],
};

export const getPartManufacturer = spawnGetApiFunction({ table, query });
export const getPartManufacturersByIds = spawnListInApiFunction({ table, query });
export const createPartManufacturer = spawnCreateApiFunction({ table, query });
export const updatePartManufacturer = spawnUpdateApiFunction({ table, query });
export const deletePartManufacturer = spawnDeleteApiFunction({ table });

export async function getPaginatedPartManufacturers({
  dataTableOptions,
  customFilters,
  customOrFilters,
}: QueryPaginationFilters) {
  const { data, count, error } = await createPaginatedSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartManufacturers.searchables,
      sortables: apiConfigPartManufacturers.sortables,
    },
    dataTableOptions,
    customFilters,
    customOrFilters,
  });

  if (error) throw error;
  return { data, count };
}

export async function getPartManufacturersBySearch({
  searchOptions,
  customFilters,
  customOrFilters,
  limit,
}: SearchOptionFilters) {
  const { data, count, error } = await createSearchSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartManufacturers.searchables,
      sortables: apiConfigPartManufacturers.sortables,
    },
    searchOptions,
    customFilters,
    customOrFilters,
    limit,
  });

  if (error) throw error;
  return { data, count };
}
